import { Sparkles } from 'lucide-react'
import { cn } from '@/lib/utils'

/**
 * Phase 19: small "Seed" pill rendered on Project cards + headers when the Author is an
 * honest-seed persona. Gate is `author.badgeSeedStatus`, not `project.generationSource` — see
 * Phase 19 plan §1 for the two-tier rationale.
 */
export const AISeedBadge = ({
  size = 'sm',
  className,
}: {
  size?: 'sm' | 'md'
  className?: string
}) => (
  <span
    title="ToDone seed account — projects created from a reference source by the AI assistant during the pre-launch test phase."
    className={cn(
      'inline-flex items-center gap-1 rounded-full border border-amber-300/60 bg-amber-50 font-medium text-amber-800 dark:border-amber-400/30 dark:bg-amber-950/40 dark:text-amber-200',
      size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs',
      className
    )}
  >
    <Sparkles className={size === 'sm' ? 'h-2.5 w-2.5' : 'h-3 w-3'} aria-hidden />
    Seed
  </span>
)
